<template>
  <!-- 在线月度分析报告 -->
  <div class="analysisReport">
    <!-- <el-button type="primary" class="export" @click="downloadPage('pdfPrint',header.zykNum,header.zykName)">导出</el-button> -->
    <el-button class="export" type="primary" size="small" @click="toImage">生成PDF</el-button>
    <div class="analysisReport_box" id="pdfPrint">
      <div class="header_titles">
        <h1>国家级教育智慧教育平台专业与课程服务中心</h1>
        <h1>2022年3季度运行分析报告</h1>
        <!-- <h1>职业教育“{{header.zykName}}”专业教学资源库({{header.zykNum}})</h1>
          <h1 style="margin-top: 15px;">{{yearMonthText}}</h1> -->
        <div class="number_time">
          <div>
            <span></span>
            <span>统计时间：2022-07-01 至 2022-09-30</span>
            <!-- <span>主持单位：{{header.allHostUnit}}</span> -->
          </div>
          <p></p>
          <p></p>
        </div>
      </div>

      <div class="division">
        <span></span>
      </div>
      <!-- 1.河北省监测总览 -->
      <div class="chart_box">
        <!-- 数据量{{overview.zykCount}}T。 -->
        <h1>1. 河北省监测总览</h1>
        <p>
          自2022年03月28日开始，国家职业教育智慧教育平台专业与课程服务中心上线，专业与课程服务中心监测平台（以下简称“监测平台”）随即开始对专业教学资源库、
          在线开放课及视频公开课进行运行监测并提供数据分析服务。
        </p>
        <p>截至2022年9月30日，据监测平台统计，河北省共建专业教学资源库{{overview.zykCount}}个，在线精品课{{overview.boutiqueCount}}门，视频公开课{{overview.openCount}}门，累计访问量{{(overview.total > 100000000?(overview.total / 100000000).toFixed(2) +'亿':overview.total)}}次，参与院校有{{overview.schoolCount}}所，覆盖平台{{overview.platForm}}个，具体分析结果如下：
        </p>
        <p>专业与课程服务中心河北省，用户数{{userData.total>10000?(userData.total / 10000).toFixed(2)+'万':userData.total}}，教师数{{userData.teacher}}名，学生数{{userData.student>10000?(userData.student / 10000).toFixed(2) + '万':userData.student}}名，交流互动数{{userData.num>10000000?(overview.total/10000000).toFixed(2) + '万':overview.total}}次。</p>

        <div style="height:40px"></div>

        <div class="chart_box">
          <!-- 1.1 -->
          <h2>1.1. 总体建设及应用分析</h2>
          <!-- 图 1 用户类型分布(单位：人) -->
          <div class="chart_box">
            <h3>1.1.1. 用户建设及应用</h3>
            <p>
              截至2022年9月30日，{{this.province}}省注册用户总计{{userData.total>10000?(userData.total / 10000).toFixed(2) +'万':userData.total}}，其中{{userType.student.name}}{{userData.student>10000?(userData.student / 10000).toFixed(2) + '万':userData.student}}，占比{{userType.Sproportion}}%；{{userType.teacher.name}}{{userType.teacher.value}}，占比{{userType.Tproportion}}%。具体情况如下图所示：
            </p>
            <div class="standards_content echartsHeight">
              <circularChart :refId="'typeDistributionChart'" :datas='userType.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
            </div>
            <div class="chart_name">图 1 用户类型分布</div>
          </div>

          <div class="chart_box">
            <!-- 图 2 近一年教师和学生访问情况 -->
            <p>近一年学生用户访问总量达{{userTypeVisit.Stotal>1000000?(userTypeVisit.Stotal / 10000).toFixed(2)+'万':userTypeVisit.Stotal}}次，教师用户访问量达{{userTypeVisit.Ttotal>10000?(userTypeVisit.Ttotal / 10000).toFixed(2)+'万':userTypeVisit.Ttotal}}次，具体访问趋势如下图所示：</p>
            <div class="standards_content echartsHeight">
              <discountChart :refId="'usersMonthChart'" :datas='userTypeVisit.dataList' :transverseData='userTypeVisit.transverseData' :colorList='userTypeVisit.colorList' :legendList="userTypeVisit.legendList" :innerText="'单位：次'"></discountChart>
            </div>
            <div class="chart_name">图 2 近一年教师和学生访问情况</div>
          </div>

          <!-- 1.1.2 -->
          <div class="chart_box" style="margin-left:15px;">
            <!-- 图 3 课程建设及应用 -->
            <h3>1.1.2. 课程建设及应用</h3>
            <div class="chart_box">
              <p>截至2022年9月30日，河北省专业与课程服务中心共计{{courseBuild.total}}门课程，其中{{courseBuild.MaxArr.name}}量最多，占比{{((courseBuild.MaxArr.value / courseBuild.total)*100).toFixed(2)}}%，具体课程来源分布如下图所示：</p>
              <div class="standards_content echartsHeight">
                <circularChart :refId="'typeDistributionChart'" :datas='courseBuild.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
              </div>
              <div class="chart_name">图 3 课程建设及应用</div>
            </div>

            <!-- 图 4 专业大类课程数量排名（前十名） -->
            <div class="chart_box">
              <p>按专业大类分析，截至2022年9月30日《{{coursesTop.fristItem.name}}》的课程数量最多，共{{coursesTop.fristItem.value}}门课程；其次是《{{coursesTop.secondItem.name}}》的课程，共{{coursesTop.secondItem.value}}门。具体专业大类课程数量排名（前十名）如下图所示：</p>
              <div class="standards_content echartsHeight">
                <tcolumnarChart :refId="'typeDistributionChart'" :datas='coursesTop.dataList' :transverseData="coursesTop.transverseData" :colorList='coursesTop.colorList' :innerText="'单位：门'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
              </div>
              <div class="chart_name">图 4 专业大类课程数量排名（前十名）</div>
            </div>

            <!-- 图 5 课程被访问总量 -->
            <div class="chart_box">
              <p>截至2022年9月30日，近一年课程被访问总量达{{courseTalk.courseTotal>100000000?(courseTalk.courseTotal/100000000).toFixed(2) + '亿':courseTalk.courseTotal}}次，日访问量达{{courseTalk.courseAvg>10000?(courseTalk.courseAvg / 10000).toFixed(2) +'万':courseTalk.courseAvg}}次，具体访问趋势如下图所示：</p>
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :datas='courseTalk.dataList' :transverseData='courseTalk.transverseData' :colorList='courseTalk.colorList' :innerText="'单位：次'"></discountChart>
              </div>
              <div class="chart_name">图 5 课程被访问总量</div>
            </div>

            <!-- 课程被访问量排名（前十五名） -->
            <div class="chart_box">
              <p>据监测平台统计，截至2022年9月30日，被访问量居首的课程是《{{courseRank.Frist.courseName}}》，高达{{courseRank.Frist.courseTotalVisit>10000000?(courseRank.Frist.courseTotalVisit / 10000).toFixed(2)+'万':courseRank.Frist.courseTotalVisit}}次，具体课程被访问量排名（前十五名）如下表所示：</p>
              <div class="biaoge">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>课程名称</th>
                    <th>课程来源</th>
                    <th>建设院校</th>
                    <th>访问量（次）</th>
                  </tr>

                  <tr v-for="(item,index) in courseRank.dataList" :key="index" v-show="courseRank.dataList.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.courseName}}</td>
                    <td>{{item.courseType}}</td>
                    <td>{{item.schoolName}}</td>
                    <td>{{item.courseTotalVisit}}</td>
                  </tr>
                  <tr v-show="courseRank.dataList.length == 0" class="nothing">
                    <td colspan="5">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 1 课程被访问量排名（前十五名）</div>
            </div>
          </div>

          <!-- 1.1.3 -->
          <div class="chart_box" style="margin-left:15px;">
            <!-- 图 7 课程建设及应用 -->
            <h3>1.1.3. 资源建设及应用</h3>
            <div class="chart_box">
              <p>截至2022年9月30日，专业与课程服务中心资源总数达{{resourceType.total>10000?(resourceType.total / 10000).toFixed(2)+'万':resourceType.total}}条资源。从资源类型来看，从资源类型来看，{{resourceType.Max.name}}数量最多，高达{{resourceType.Max.value>10000?(resourceType.Max.value / 10000).toFixed(2) +'万':resourceType.Max.value}}条，占比{{((resourceType.Max.value / resourceType.total)*100).toFixed(2)}}%，具体资源类型分布如下图所示：</p>
              <div class="standards_content echartsHeight">
                <circularChart :refId="'typeDistributionChart'" :datas='resourceType.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
              </div>
              <div class="chart_name">图 6 各类型资源</div>
            </div>

            <!-- 图 4 专业大类课程数量排名（前十名） -->
            <div class="chart_box">
              <p>资源访问总量已达{{resourceType.resourceTotal>10000?(resourceType.resourceTotal / 10000).toFixed(2) + '万':resourceType.resourceTotal}}余次，日均访问资源{{resourceType.resourceAvg}}次；其中访问次数最多的资源是《{{resourceType.tableTop.name}}》，资源被访问量排名（前十五名）如下表所示：</p>
              <div class="biaoge">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>资源名称</th>
                    <th>资源类型</th>
                    <th>资源来源</th>
                    <th>建设院校</th>
                    <th>访问量（次）</th>
                  </tr>

                  <tr v-for="(item,index) in resourceType.TableDataList" :key="index" v-show="resourceType.TableDataList.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.reportType}}</td>
                    <td>{{item.zykName}}</td>
                    <td>{{item.school}}</td>
                    <td>{{parseInt(item.num)}}</td>
                  </tr>
                  <tr v-show="resourceType.TableDataList.length == 0" class="nothing">
                    <td colspan="6">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 2 资源被访问量排名（前十五名）</div>
            </div>
          </div>
        </div>

        <div class="chart_box">
          <h2>1.2. 院校参建情况分析</h2>
          <div class="chart_box">
            <h3>1.2.1. 院校参与教师与学生情况</h3>
            <p>
              截至2022年9月30日，河北省注册用户总计{{userData.total>10000?(userData.total/ 10000).toFixed(2) + '万':userData.total}}，参与院校{{overview.schoolCount}}所；其中参与参建教师最多的是《{{tearcherRank.Frist.name}}》，共{{tearcherRank.Frist.value}}名；参与线上学习的学生用户最多的是《{{studentRank.Frist.name}}》；交流互动量最多的是《{{schoolComRank.Frist.name}}》。
            </p>
            <!-- 图 8 河北省院校参建教师数排名（前十名） -->
            <div class="standards_content echartsHeight">
              <tcolumnarChart :refId="'typeDistributionChart'" :datas='tearcherRank.dataList' :transverseData="tearcherRank.transverseData" :colorList='tearcherRank.colorList' :colorName='2' :innerText="'单位：人'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
            </div>
            <div class="chart_name">图 7 河北省院校参建教师数排名（前十五名）</div>

            <div class="standards_content echartsHeight">
              <tcolumnarChart :refId="'typeDistributionChart'" :datas='studentRank.dataList' :transverseData="studentRank.transverseData" :colorList='studentRank.colorList' :colorName='2' :innerText="'单位：人'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
            </div>
            <div class="chart_name">图 8 河北省院校学生在线学习用户数排名（前十五名）</div>

            <div class="standards_content echartsHeight">
              <tcolumnarChart :refId="'typeDistributionChart'" :datas='schoolComRank.dataList' :transverseData="schoolComRank.transverseData" :colorList='schoolComRank.colorList' :colorName='2' :innerText="'单位：人'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
            </div>
            <div class="chart_name">图 9 河北省各院校交流互动量排名（前十五名）</div>
          </div>

          <!-- 本省院校的开课期数为N期，开课期数最多的属于XXX院校，共N万期，具体如下所示： -->
          <div class="chart_box" style="margin-left:15px;">
            <h3>1.2.2. 院校课程建设及应用情况</h3>
            <p>
              截至2022年9月30日，河北省建设课程总计{{courseBuild.total}}门，参与院校{{overview.schoolCount}}所。其中建设课程数量最多的是《{{opencourseRank.Frist.name}}》，高达{{opencourseRank.Frist.value>10000?(opencourseRank.Frist.value/ 10000).toFixed(2)+'万':opencourseRank.Frist.value}}门；具体如下所示：
            </p>
            <!-- 图 8 河北省院校参建教师数排名（前十名） -->
            <div class="standards_content echartsHeight">
              <tcolumnarChart :refId="'typeDistributionChart'" :datas='opencourseRank.dataList' :transverseData="opencourseRank.transverseData" :colorList='opencourseRank.colorList' :colorName='2' :innerText="'单位：门'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
            </div>
            <div class="chart_name">图 10 河北省院校建设课程数量排名（前十五名）</div>
          </div>

          <div class="chart_box" style="margin-left:15px;">
            <h3>1.2.3. 院校资源建设及应用情况</h3>
            <p>
              截至2022年9月30日，河北省建设资源总数{{resourceType.total>10000?(resourceType.total / 10000).toFixed(2)+'万':resourceType.total}}条，参与院校{{overview.schoolCount}}所，其中建设资源数量最多的是《{{schoolResource.Frist.name}}》，高达{{schoolResource.Frist.value>10000?(schoolResource.Frist.value / 10000).toFixed(2)+'万':schoolResource.Frist.value}}条。本省访问资源的总量达{{schoolResourceVisit.total > 10000?(schoolResourceVisit.total/10000).toFixed(2)+'万':schoolResourceVisit.total}}次，访问资源总量最多的是《{{schoolResourceVisit.Frist.name}}》。
            </p>
            <!-- 图 8 河北省院校建设资源数排名（前十五名) -->
            <div class="standards_content echartsHeight">
              <tcolumnarChart :refId="'typeDistributionChart'" :datas='schoolResource.dataList' :transverseData="schoolResource.transverseData" :colorList='schoolResource.colorList' :innerText="'单位：条'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
            </div>
            <div class="chart_name">图 11 河北省院校建设资源数排名（前十五名)</div>

            <div class="standards_content echartsHeight">
              <tcolumnarChart :refId="'typeDistributionChart'" :datas='schoolResourceVisit.dataList' :transverseData="schoolResourceVisit.transverseData" :colorList='schoolResourceVisit.colorList' :innerText="'单位：次'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
            </div>
            <div class="chart_name">图 12 河北省院校访问资源数排名（前十五名）</div>
          </div>
        </div>

        <div class="chart_box">
          <h2>1.3. 2022-07-01至2022-09-30河北省整体运行情况分析</h2>
          <div class="chart_box">
            <div class=" chart_box">
              <h3>1.3.1. 用户应用情况</h3>
              <p>
                在该段时间内，河北省新增注册用户{{sectionUCR.userNewTotal}}名，趋势图如下：
              </p>
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :datas='sectionUCR.userNewDataList' :transverseData='sectionUCR.userNewTransverseData' :colorList='sectionUCR.colorList' :innerText="'单位：名'" :isaverage="true"></discountChart>
              </div>
              <div class="chart_name">图 13 注册用户趋势图。</div>
            </div>

            <div class="chart_box">
              <p>用户总访问量达{{sectionUCR.userVisitsTotal>10000?(sectionUCR.userVisitsTotal / 10000).toFixed(2) +'万':sectionUCR.userVisitsTotal}}次，具体访问趋势如下：</p>
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :datas='sectionUCR.uservisitsDataList' :transverseData='sectionUCR.uservisitsTransverseData' :colorList='sectionUCR.colorList' :innerText="'单位：次'" :isaverage="true"></discountChart>
              </div>
              <div class="chart_name">图 14 为用户访问趋势图</div>
            </div>
          </div>

          <div class="chart_box" style="margin-left:15px;">
            <h3>1.3.2. 课程运行情况</h3>
            <div class="chart_box">
              <p>
                在该段时间内，河北省新增课程数为{{sectionUCR.courseNewTotal}}门；课程访问量为{{sectionUCR.courseVisitsTotal>10000?(sectionUCR.courseVisitsTotal/ 10000).toFixed(2) + '万':sectionUCR.courseVisitsTotal}}次
              </p>
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :datas='sectionUCR.courseNewDataList' :transverseData='sectionUCR.courseNewTransverseData' :colorList='sectionUCR.colorList' :innerText="'单位：门'"></discountChart>
              </div>
              <div class="chart_name">图 15 新增课程趋势</div>
            </div>

            <div class="chart_box">
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :datas='sectionUCR.courseVisitsDataList' :transverseData='sectionUCR.courseVisitsTransverseData' :colorList='sectionUCR.colorList' :innerText="'单位：次'" :isaverage="true"></discountChart>
              </div>
              <div class="chart_name">图 16 课程被访问量趋势图</div>
            </div>
          </div>

          <div class="chart_box" style="margin-left:15px;">
            <h3>1.3.3. 资源运行情况</h3>
            <!-- 资源被访问次数达N次。 -->
            <div class="chart_box">
              <p>在该段时间内，河北省新增资源数为{{sectionUCR.resourceNewTotal}}个，河北省资源访问次数为{{sectionUCR.resourceVisitsTotal>10000?(sectionUCR.resourceVisitsTotal / 10000).toFixed(2)+'万':sectionUCR.resourceVisitsTotal}}次</p>
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :datas='sectionUCR.resourceNewDataList' :transverseData='sectionUCR.resourceNewTransverseData' :colorList='sectionUCR.colorList' :innerText="'单位：个'" :isaverage="true"></discountChart>
              </div>
              <div class="chart_name">图 17 新增资源趋势。</div>
            </div>

            <div class="chart_box">
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :datas='sectionUCR.resourceVisitsDataList' :transverseData='sectionUCR.resourceVisitsTransverseData' :colorList='sectionUCR.colorList' :innerText="'单位：次'" :isaverage="true"></discountChart>
              </div>
              <div class="chart_name">图 18 被访问量趋势图</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 2. 河北省专业教学资源库应用分析 -->
      <div class="chart_box">
        <h1>2. 河北省专业教学资源库应用分析</h1>
        <div class="chart_box">
          <h2>2.1. 资源库总体情况</h2>
          <p>
            截至2022年9月30日，河北省主持建设的资源库共计{{zykAll.countryProvinceTotal + zykAll.provinceProvinceTotal + zykAll.schoolProvinceTotal}}个，其中国家级资源库{{zykAll.countryProvinceTotal}}个，省级资源库{{zykAll.provinceProvinceTotal}}个，校级资源库{{zykAll.schoolProvinceTotal}}个，覆盖{{zykBigType.dataList.length}}个专业大类。
            目前，这些资源库中课程总量已达{{opencourseRank.total}}门，资源总量达{{resourceType.total>10000?(resourceType.total / 10000).toFixed(2)+'万':resourceType.total}}余条，共有注册用户{{userData.total>10000?(userData.total / 10000).toFixed(2) +'万':userData.total}}余人，总访问次数{{(overview.total > 100000000?(overview.total / 100000000).toFixed(2) +'亿':overview.total)}}次，为推动省内职业教育专业教学改革和职业院校信息化建设贡献了力量。具体建设应用情况分析如下：
          </p>
          <div class="chart_box" style="margin-left:15px;">
            <h3>2.1.1. 用户建设及应用情况</h3>
            <p>
              当前，河北省资源库共有注册用户{{zykUser.total>10000?(zykUser.total/10000).toFixed(2)+'万':zykUser.total}}余人，参与院校{{overview.schoolCount}}所。按用户身份类型统计，教师{{zykUser.tearcher.value}}余人，学生{{zykUser.student.value>10000?(zykUser.student.value/10000).toFixed(2)+'万':zykUser.student.value}}余人，企业员工{{zykUser.social.value}}人，
              社会学习者用户{{zykUser.enterprise.value}}余人。其中注册用户最多的是《{{schoolActive.school}}》，为{{schoolActive.value}}人。
            </p>
            <div class="chart_box">
              <p>
                目前，这些资源库中用户访问资源总量约{{zykUserVisit.total>100000000?(zykUserVisit.total / 100000000).toFixed(2) +'亿':zykUserVisit.total}}次，活跃学生数达{{zykUserActive.total>10000?(zykUserActive.total/10000).toFixed(2):zykUserActive.total}}万，省内在线学习人数最多的则是《{{studentRank.Frist.name}}》，共{{studentRank.total>10000?(studentRank.total/10000).toFixed(2)+'万':studentRank.total}}人；互动交流次数累计{{schoolComRank.total>10000?(schoolComRank.total/ 10000).toFixed(2)+'万':schoolComRank.total}}次，
                省内互动交流频次最多的是《{{schoolComRank.Frist.name}}》，其次是《{{schoolComRank.Second.name}}》。分布详情如下所示：
              </p>
              <!-- 图 1 用户类型分布(单位：人) -->
              <div class="standards_content echartsHeight">
                <circularChart :refId="'typeDistributionChart'" :datas='zykUser.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></circularChart>
              </div>
              <div class="chart_name">图 19 用户整体情况(单位：人)</div>
            </div>

            <div class="chart_box">
              <!-- 图 2 近一年教师和学生访问情况 -->
              <p>近一年学生用户访问总量达{{userTypeVisit.Stotal>10000?(userTypeVisit.Stotal/ 10000).toFixed(2)+'万':userTypeVisit.Stotal}}次，教师用户访问量达{{userTypeVisit.Ttotal>10000?(userTypeVisit.Ttotal/10000).toFixed(2)+'万':userTypeVisit.Ttotal}}次，具体访问趋势如下图所示：</p>
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :datas='userTypeVisit.dataList' :transverseData='userTypeVisit.transverseData' :colorList='userTypeVisit.colorList' :legendList="userTypeVisit.legendList" :innerText="'单位：次'"></discountChart>
              </div>
              <div class="chart_name">图 20 最近一年教师和学生访问情况</div>
            </div>

            <div class="chart_box">
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :datas='userTypeVisit.dataList2' :transverseData='userTypeVisit.transverseData' :colorList='userTypeVisit.colorList' :legendList="userTypeVisit.legendList2" :innerText="'单位：次'" :isaverage="true"></discountChart>
              </div>
              <div class="chart_name">图 21 最近一年社会学习者和企业用户访问情况</div>
            </div>

            <div class="chart_box">
              <p>截至2022年9月30日，参与各院校资源库用户在线学习人数情况排名（前十名）如下表所示：</p>
              <div class="biaoge">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>院校</th>
                    <th>活跃教师数（人）</th>
                    <th>活跃学生数（人）</th>
                    <th>交流互动量（次）</th>
                  </tr>

                  <tr v-for="(item,index) in zykUserActive.dataList" :key="index" v-show="zykUserActive.dataList.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.school}}</td>
                    <td>{{item.activeTeacherNum}}</td>
                    <td>{{item.activeNum}}</td>
                    <td>{{item.formun}}</td>
                  </tr>
                  <tr v-show="zykUserActive.dataList.length == 0" class="nothing">
                    <td colspan="5">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 3 课程被访问量排名（前十名）</div>
            </div>
          </div>

          <div class="chart_box">
            <h3>2.1.2. 课程建设及应用情况</h3>
            <div class="chart_box">
              <p>
                当前，河北省资源库项目课程总量达到{{zykCourseBuild.standard + zykCourseBuild.personality}}门，其中标准化课程{{zykCourseBuild.standard}}门，个性化课程{{zykCourseBuild.personality}}门。课程访问日均次数{{((courseBuild.total) / 365).toFixed(0)}}次，其中，注册学生用户访问最多的课程是《{{zykCourseBuild.name}}》，属于{{zykCourseBuild.zykName}}资源库。
                课程按类型分布详情如下：
              </p>

              <div class="standards_content echartsHeight">
                <tcolumnarChart :refId="'typeDistributionChart'" :datas='zykCourseBuild.dataList' :transverseData="zykCourseBuild.transverseData" :colorList='zykCourseBuild.colorList' :colorName='2' :innerText="'单位：门'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
              </div>
              <div class="chart_name">图 22 课程整体情况(单位：门)</div>
            </div>

            <div class="chart_box">
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :datas='courseTalk.dataList' :transverseData='courseTalk.transverseData' :colorList='courseTalk.colorList' :innerText="'单位：次'" :isaverage="true"></discountChart>
              </div>
              <div class="chart_name">图 23 最近一年课程访问情况</div>
            </div>
          </div>

          <div class="chart_box">
            <h3>2.1.3. 资源建设应用情况</h3>
            <p>
              河北省资源库项目资源数量达{{resourceType.total>10000?(resourceType.total / 10000).toFixed(2)+'万':resourceType.total}}余条， 其中《{{resourceType.Max.name}}》资源数量最多，{{resourceType.Max.value>10000?(resourceType.Max.value/10000).toFixed(2)+'万':resourceType.Max.value}}条。资源访问总量已达{{resourceType.resourceTotal>10000?(resourceType.resourceTotal/10000).toFixed(2)+'万':resourceType.resourceTotal}}余次，日均访问资源{{resourceType.resourceAvg}}次；
              其中访问次数最多的资源是《{{resourceType.tableTop.name}}》，属于《{{resourceType.tableTop.zykName}}》资源库
            </p>
            <div class="chart_box">
              <p>资源按类型分布详情如下：</p>
              <div class="standards_content echartsHeight">
                <tcolumnarChart :refId="'typeDistributionChart'" :datas='resourceType.valueArr' :transverseData="resourceType.keyArr" :colorList='resourceType.colorList' :colorName='2' :innerText="'单位：条'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
              </div>
              <div class="chart_name">图 26 资源整体情况(单位：条)</div>
            </div>

            <div class="chart_box">
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :datas='resouceTalk.dataList' :transverseData='resouceTalk.transverseData' :colorList='resouceTalk.colorList' :innerText="'单位：次'" :isaverage="true"></discountChart>
              </div>
              <div class="chart_name">图 27 最近一年资源访问情况</div>
            </div>
          </div>

          <div class="chart_box">
            <h3>2.1.4. 资源库总体应用情况分析</h3>
            <p>（1）覆盖专业大类分析</p>
            <div class="chart_box">
              <p>
                截止到2022年9月30日，河北省资源库覆盖{{zykBigType.dataList.length}}个专业大类。从专业大类分布看，所属{{zykBigType.Max.name}}资源库最多，占比达{{((zykBigType.Max.value / zykBigType.total)*100).toFixed(2)}}%，具体分布如下图所示：
              </p>
              <div class="standards_content echartsHeight">
                <circularChart :refId="'typeDistributionChart'" :datas='zykBigType.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'25%'" :legendBackgroundColor="true" :legendLeft="'50%'" :circleSize="80" :seriesRight="'50%'"></circularChart>
              </div>
              <div class="chart_name">图 28 资源库专业大类分布情况</div>
            </div>

            <div class="chart_box">
              <p>（2）按照访问量排名</p>
              <p>
                资源库项目中，《{{zykUserVisit.Frist.zykName}}资源库》的访问量最多，紧随其后的是《{{zykUserVisit.Second.zykName}}资源库》和《{{zykUserVisit.Thrend.zykName}}资源库》。具体按照访问情况排名（前十五名）如下表所示：
              </p>
              <div class="biaoge">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>资源库名称</th>
                    <th>院校</th>
                    <th>访问量（次）</th>
                  </tr>

                  <tr v-for="(item,index) in zykUserVisit.dataList" :key="index" v-show="zykUserVisit.dataList.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.zykName}}</td>
                    <td>{{item.schoolName}}</td>
                    <td>{{parseInt(item.logNum)}}</td>
                  </tr>
                  <tr v-show="zykUserVisit.dataList.length == 0" class="nothing">
                    <td colspan="5">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 3 河北省资源库访问量情况排名（前十五名）</div>
            </div>

            <div class="chart_box">
              <p>（3）按用户活跃情况排名</p>
              <p>
                资源库项目中，《{{zykUserActiveRank.Frist.zykName}}》资源库的活跃用户数最多，紧随其后的是《{{zykUserActiveRank.Second.zykName}}》资源库和《{{zykUserActiveRank.Thrend.zykName}}》资源库。具体按照用户活跃情况排名（前十名）如下表所示：
              </p>
              <div class="biaoge">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>资源库名称</th>
                    <th>院校</th>
                    <th>级别</th>
                    <th>用户活跃次数(次)</th>
                  </tr>

                  <tr v-for="(item,index) in zykUserActiveRank.dataList" :key="index" v-show="zykUserActiveRank.dataList.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.zykName}}</td>
                    <td>{{item.firstChargeUnit}}</td>
                    <td>{{item.projectTypeCn}}</td>
                    <td>{{parseInt(item.num)}}</td>
                  </tr>
                  <tr v-show="zykUserActiveRank.dataList.length == 0" class="nothing">
                    <td colspan="4">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 4 河北省资源库用户活跃情况排名（前十名）</div>
            </div>
          </div>
        </div>

        <div class="chart_box">
          <h2>2.2. 2022-07-01至2022-09-30河北省资源库运行情况分析</h2>
          <h3>2.2.1. 资源库用户运行情况</h3>
          <div class="chart_box" style="margin-left:15px;">
            <div class="chart_box">
              <p>
                在分析时间段内，资源库项目中河北省累计活跃用户{{zykSection.userActiveTotal}}人，累计访问量{{zykSection.userActiveLogNum>10000?(zykSection.userActiveLogNum/10000).toFixed(2) +'万':zykSection.userActiveLogNum}}次。其中河北省学生用户{{zykSection.SNumber.num}}人，累计访问共{{zykSection.SNumber.logNum>10000?(zykSection.SNumber.logNum/10000).toFixed(2)+'万':zykSection.SNumber.logNum}}次；教师用户{{zykSection.TNumber.num}}人，累计访问共{{zykSection.TNumber.logNum >10000?(zykSection.TNumber.logNum / 10000).toFixed(2) + '万':zykSection.TNumber.logNum}}次；企业员工{{zykSection.ENumber.num}}人，累计访问{{zykSection.ENumber.logNum>10000?(zykSection.ENumber.logNum/10000).toFixed(2)+'万':zykSection.ENumber.logNum}}次； 社会学习者{{zykSection.Social.num}}人，累计访问资源库{{zykSection.Social.logNum>10000?(zykSection.Social.logNum/10000).toFixed(2)+'万':zykSection.Social.logNum}}次。各类型用户访问趋势图如下：
              </p>
              <!-- 图 1 用户类型分布(单位：人) -->
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :datas='zykSection.userActiveDataList' :transverseData='zykSection.userActiveTransverseData' :colorList='zykSection.colorList' :legendList="zykSection.legendList" :innerText="'单位：人'"></discountChart>
              </div>
              <div class="chart_name">图29 2022年7月1号至2022年9月30号资源库各类型用户访问趋势</div>
            </div>

            <div class="chart_box">
              <p>（2）用户活跃情况分析</p>
              <p>
                在该时间段内，河北省资源库月活共{{zykSection.userActiveTotal}}次，平均月活{{(zykSection.userActiveTotal / 3).toFixed(2)}}次。
              </p>
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :datas='zykSection.userData' :transverseData='zykSection.userTranserve' :colorList='zykSection.colorList' :innerText="'单位：次'"></discountChart>
              </div>
              <div class="chart_name">图30 2022年7月1号至2022年9月30号河北省资源库月活趋势</div>
            </div>

            <div class="chart_box">
              <p>（3）资源库用户新增情况分析</p>
              <p>在该时间段内，河北省学生用户新增共{{zykSectionUserAdd.Stotal}}人，教师用户新增共{{zykSectionUserAdd.Ttotal}}人，新增情况如下所示：</p>
              <!-- 图 1 用户类型分布(单位：人) -->
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :datas='zykSectionUserAdd.dataList' :transverseData='zykSectionUserAdd.transverseData' :colorList='zykSectionUserAdd.colorList' :legendList="zykSectionUserAdd.legendList" :innerText="'单位：人'"></discountChart>
              </div>
              <div class="chart_name">图31 2022年7月1号至2022年9月30号资源库各类型用户访问趋势</div>
            </div>

            <div class="chart_box">
              <p>（4）资源库被用户访问情况排名分析</p>
              <p>在该时间段内，河北省资源库项目中被用户访问最多的资源库是{{zykTalkRank.Frist.projectTypeCn}}的《{{zykTalkRank.Frist.zykName}}》资源库，被访问最少的资源库是《{{zykTalkRank.Last.zykName}}》资源库。具体被访问资源库排名前十名和后十名如下图所示：</p>
              <div class="chart_box">
                <div class="biaoge">
                  <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                    <tr>
                      <th>序号</th>
                      <th>资源库名称</th>
                      <th>所属院校</th>
                      <th>级别</th>
                      <th>访问量（次）</th>
                    </tr>

                    <tr v-for="(item,index) in zykTalkRank.dataList" :key="index" v-show="zykTalkRank.dataList.length > 0">
                      <td>{{index+1}}</td>
                      <td>{{item.zykName}}</td>
                      <td>{{item.firstChargeUnit}}</td>
                      <td>{{item.projectTypeCn}}</td>
                      <td>{{parseInt(item.num)}}</td>
                    </tr>
                    <tr v-show="zykTalkRank.dataList.length == 0" class="nothing">
                      <td colspan="5">无</td>
                    </tr>
                  </table>
                </div>
                <div class="chart_name">表5 2022年7月1号至2022年9月30号河北省资源库访问量排行榜（前十名）</div>
              </div>
            </div>

            <div class="chart_box">
              <div class="biaoge">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>序号</th>
                    <th>资源库名称</th>
                    <th>所属院校</th>
                    <th>级别</th>
                    <th>访问量（次）</th>
                  </tr>

                  <tr v-for="(item,index) in zykTalkRank.lastList" :key="index" v-show="zykTalkRank.lastList.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.zykName}}</td>
                    <td>{{item.firstChargeUnit}}</td>
                    <td>{{item.projectTypeCn}}</td>
                    <td>{{parseInt(item.num)}}</td>
                  </tr>
                  <tr v-show="zykTalkRank.lastList.length == 0" class="nothing">
                    <td colspan="5">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表6 2022年7月1号至2022年9月30号河北省资源库访问量排行榜（后十名）</div>
            </div>
          </div>

          <div class="chart_box" style="margin-left:15px;">
            <div class="chart_box">
              <h3>2.2.2. 资源库课程运行情况</h3>
              <div class="chart_box">
                <p>
                  在分析时间段内，河北省资源库新增课程数为{{sectionUCR.courseNewTotal}}门，新增情况如下：
                </p>
                <!-- 图 1 用户类型分布(单位：人) -->
                <div class="standards_content echartsHeight">
                  <discountChart :refId="'usersMonthChart'" :datas='sectionUCR.courseNewDataList' :transverseData='sectionUCR.courseNewTransverseData' :colorList='sectionUCR.colorList' :innerText="'单位：门'"></discountChart>
                </div>
                <div class="chart_name">图32 2022年7月1日至2022年9月30日河北省资源库课程新增趋势</div>
              </div>

              <div class="chart_box">
                <div class="standards_content echartsHeight">
                  <tcolumnarChart :refId="'typeDistributionChart'" :datas='zykVisiRank.dataList' :transverseData="zykVisiRank.transverseData" :colorList='zykVisiRank.colorList' :colorName='2' :innerText="'单位：次'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
                </div>
                <div class="chart_name">图33 2022年7月1日至2022年9月30日河北省资源库课程被访问量排名（前十名）</div>
              </div>
            </div>

            <div class="chart_box">
              <h3>2.2.3. 资源库资源运行情况</h3>
              <p>在分析时间内，河北省新增资源数为{{sectionUCR.resourceNewTotal}}条，资源被访问量达{{zykResource.total>10000?(zykResource.total/10000).toFixed(2) +'万':zykResource.total}}次，其中《{{zykResource.Frist.name}}》资源被访问的次数最多，达{{zykResource.Frist.value>10000?(zykResource.Frist.value / 10000).toFixed(3)+'万':zykResource.Frist.value}}次。</p>
              <div class="standards_content echartsHeight">
                <discountChart :refId="'usersMonthChart'" :datas='sectionUCR.resourceNewDataList' :transverseData='sectionUCR.resourceNewTransverseData' :colorList='sectionUCR.colorList' :innerText="'单位：条'"></discountChart>
              </div>
              <div class="chart_name">图34 2022-01-01至2022-06-30河北省资源库资源新增趋势</div>
            </div>

            <div class="chart_box">
              <div class="standards_content echartsHeight">
                <tcolumnarChart :refId="'typeDistributionChart'" :datas='zykResource.dataList' :transverseData="zykResource.transverseData" :colorList='zykResource.colorList' :colorName='2' :innerText="'单位：次'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80"></tcolumnarChart>
              </div>
              <div class="chart_name">图35 2022年7月1号至2022年9月30号河北省资源库资源被访问排名（前十名）</div>
            </div>
          </div>
        </div>
      </div>

      <!-- 3.河北省在线精品课应用分析 -->
      <div class="chart_box">
        <h2>3. 河北省在线精品课应用分析</h2>
        <div class="chart_box">
          <h3>3.1. 在线精品课程建设及应用情况</h3>
          <p>
            依据监测平台统计，截止到2022年9月30日，河北省在线精品课程共建{{onlineboutiqueLevel.total}}门，其中，国家级课程有{{onlineboutiqueLevel.counrtyList.num}}门，省市级课程有{{onlineboutiqueLevel.provinceList.num}}门，校级课程有{{onlineboutiqueLevel.schoolList.num}}门，
            共覆盖平台数{{overview.platForm}}个。目前，在线精品课程已有{{onlineboutique.datas1.value}}所院校和{{onlineboutique.datas7.value}}名教师参与建设与应用；总访问量达{{onlineboutique.datas4.value>100000000?(onlineboutique.datas4.value/100000000).toFixed(2)+'亿':onlineboutique.datas4.value}}次，总开课期数为{{onlineboutique.datas3.value}}期，总课时数为{{onlineboutique.datas5.value}}小时，
            总选课人数{{onlineboutique.datas6.value>10000?(onlineboutique.datas6.value/ 10000).toFixed(2)+'万':onlineboutique.datas6.value}}人，总互动次数{{onlineboutique.datas8.value>10000?(onlineboutique.datas8.value/10000).toFixed(2)+'万':onlineboutique.datas8.value}}次。具体建设与应用情况如下
          </p>
          <div class="chart_box" style="margin-left:15px;">
            <div class="chart_box">
              <p>3.1.1. 在线精品课建设情况</p>
              <div class="chart_box">
                <p>
                  (1)参建课程数量排名
                </p>
                <p>
                  截止到2022年9月30日，在在线精品课建设中，河北省参与建设课程总数为{{onlineboutiqueLevel.total}}门，参建课程数量最多的是《{{onlineboutiqueCourseRank.CourseRankFrist.schoolname}}》，共{{onlineboutiqueCourseRank.CourseRankFrist.total}}门，具体参建院校课程数量排名（前十名）如下表所示：
                </p>
                <!-- 图 1 用户类型分布(单位：人) -->
                <div class="biaoge">
                  <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                    <tr>
                      <th>排名</th>
                      <th>院校</th>
                      <th>课程总选课人数</th>
                      <th>参建课程数</th>
                    </tr>

                    <tr v-for="(item,index) in onlineboutiqueCourseRank.total" :key="index" v-show="onlineboutiqueCourseRank.total.length > 0">
                      <td>{{index+1}}</td>
                      <td>{{item.schoolname}}</td>
                      <td>{{item.studynum}}</td>
                      <td>{{item.total}}</td>
                    </tr>
                    <tr v-show="onlineboutiqueCourseRank.total.length == 0" class="nothing">
                      <td colspan="4">无</td>
                    </tr>
                  </table>
                </div>
                <div class="chart_name">表 7 各院校参建在线精品课程数量排名（前十名）</div>
              </div>

              <!-- 图 2 近一年教师和学生访问情况 -->
              <div class="chart_box">
                <p>（2）参建课程数量专业大类分布</p>
                <p>截止到2022年9月30日，河北省课程覆盖{{onlineboutiqueCourseType.dataList.length}}个专业大类。从专业大类分布看，所属{{onlineboutiqueCourseType.Frist.name}}的课程最多，一共{{onlineboutiqueCourseType.Frist.value}}门课程，占比达{{((onlineboutiqueCourseType.Frist.value / onlineboutiqueCourseType.total)*100).toFixed(2)}}%，具体分布如下图所示：</p>
                <div class="standards_content echartsHeight">
                  <circularChart :refId="'typeDistributionChart'" :datas='onlineboutiqueCourseType.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'25%'" :legendBackgroundColor="true" :legendLeft="'50%'" :circleSize="80" :seriesRight="'50%'"></circularChart>
                </div>
                <div class="chart_name">图 37 河北省在线精品课专业大类分布情况</div>
              </div>
            </div>

            <div class="chart_box">
              <h3>3.1.2. 在线精品课访问情况</h3>
              <div class="chart_box">
                <p>
                  截止到2022年9月30日，河北省在线精品课程共计访问量{{onlineboutique.datas4.value>100000000?(onlineboutique.datas4.value/100000000).toFixed(2)+'亿':onlineboutique.datas4.value}}，访问量最高的课程是{{onlineboutiqueCourseRank.schoolName}}的《{{onlineboutiqueCourseRank.visitsFrist.courseName}}》，具体访问量排名前十名的课程信息如下：
                </p>
                <!-- 图 1 用户类型分布(单位：人) -->
                <div class="biaoge">
                  <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                    <tr>
                      <th>排名</th>
                      <th>课程</th>
                      <th>课程负责人</th>
                      <th>所属院校</th>
                      <th>级别</th>
                      <th>访问量</th>
                    </tr>

                    <tr v-for="(item,index) in onlineboutiqueCourseRank.visits" :key="index" v-show="onlineboutiqueCourseRank.visits.length > 0">
                      <td>{{index+1}}</td>
                      <td>{{item.courseName}}</td>
                      <td>{{item.majorTeacher}}</td>
                      <td>{{item.schoolName}}</td>
                      <td>{{item.level}}</td>
                      <td>{{item.courseTotalVisit}}</td>
                    </tr>
                    <tr v-show="onlineboutiqueCourseRank.visits.length == 0" class="nothing">
                      <td colspan="4">无</td>
                    </tr>
                  </table>
                </div>
                <div class="chart_name">图32 2022年7月1号至2022年9月30号河北省资源库课程新增趋势</div>
              </div>
            </div>

            <div class="chart_box">
              <h3>3.1.3. 在线精品课开课情况</h3>
              <p>
                截止到2022年9月30日，河北省在线精品课程共计开课期数{{onlineboutique.datas3.value}}期，开课期数最多的课程是{{onlineboutiqueCourseRank.semesterFrist.schoolname}}的《{{onlineboutiqueCourseRank.semesterFrist.name}}》，具体访问量排名前十名的课程信息如下：
              </p>
              <!-- 图 1 用户类型分布(单位：人) -->
              <div class="biaoge">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>课程</th>
                    <th>课程负责人</th>
                    <th>所属院校</th>
                    <th>级别</th>
                    <th>开课期数</th>
                  </tr>

                  <tr v-for="(item,index) in onlineboutiqueCourseRank.semester" :key="index" v-show="onlineboutiqueCourseRank.semester.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.teacher}}</td>
                    <td>{{item.schoolname}}</td>
                    <td>{{item.level}}</td>
                    <td>{{item.num}}</td>
                  </tr>
                  <tr v-show="onlineboutiqueCourseRank.semester.length == 0" class="nothing">
                    <td colspan="6">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 9 河北省在线精品课访问量排名（前十名）</div>
            </div>

            <div class="chart_box">
              <h3>3.1.4. 在线精品课程选课情况</h3>
              <p>
                截止到2022年9月30日，河北省在线精品课程共计选课人数{{onlineboutique.datas6.value>10000?(onlineboutique.datas6.value/ 10000).toFixed(2)+'万':onlineboutique.datas6.value}}，选课人数最多的课程是邢台职业技术学院的《{{onlineboutiqueCourseRank.studyFrist.schoolname}}》，选课人数前十名的课程信息如下：
              </p>
              <!-- 图 1 在线精品课程选课情况(单位：人) -->
              <div class="biaoge">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>课程</th>
                    <th>课程负责人</th>
                    <th>所属院校</th>
                    <th>级别</th>
                    <th>选课人数</th>
                  </tr>

                  <tr v-for="(item,index) in onlineboutiqueCourseRank.study" :key="index" v-show="onlineboutiqueCourseRank.study.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.teacher}}</td>
                    <td>{{item.schoolname}}</td>
                    <td>{{item.level}}</td>
                    <td>{{item.num}}</td>
                  </tr>
                  <tr v-show="onlineboutiqueCourseRank.study.length == 0" class="nothing">
                    <td colspan="6">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 10 河北省在线精品课开课期数排名（前十名）</div>
            </div>
          </div>
        </div>
      </div>

      <div class="chart_box">
        <h1>4. 河北省视频公开课应用分析</h1>
        <div class="chart_box">
          <h2>4.1. 河北省视频公开课建设及应用情况</h2>
          <p>
            依据监测平台统计，截止到2022年9月30日，河北省视频公开课共建{{movieLeavel.total}}门，其中，课程思政示范课有{{movieLeavel.datas4.num}}门、国家规范教材有{{movieLeavel.datas2.num}}门、公共基础课有{{movieLeavel.datas1.num}}门、教学能力比赛获奖作品有{{movieLeavel.datas3.num}}门，共覆盖平台数{{overview.platForm}}个。目前，河北省视频公开课{{movieOpen.datas6.value}}所院校和{{movieOpen.datas4.value}}名教师参与建设与应用；总访问量达{{movieOpen.datas5.value}}次，总课时数为{{movieOpen.datas2.value}}小时，总互动次数{{movieOpen.datas1.value}}期。具体建设与应用情况如下：
          </p>
          <div class="chart_box" style="margin-left:15px;">
            <div class="chart_box">
              <h3>4.1.1. 视频公开课建设情况</h3>
              <div class="chart_box">
                <p>
                  (1)参建课程数量排名
                </p>
                <p>
                  截止到2022年9月30日，在在线精品课建设中，河北省参与建设课程总数为{{movieOpenCourseRank.courseTotal}}门，参建课程数量最多的是《{{movieOpenCourseRank.CourseRankFrist.schoolname}}》，共{{movieOpenCourseRank.CourseRankFrist.total}}门，具体参建院校课程数量排名（前十名）如下表所示：
                </p>
                <!-- 图 1 用户类型分布(单位：人) -->
                <div class="biaoge">
                  <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                    <tr>
                      <th>排名</th>
                      <th>院校</th>
                      <th>课程总选课人数</th>
                      <th>参建课程数</th>
                    </tr>

                    <tr v-for="(item,index) in movieOpenCourseRank.total" :key="index" v-show="movieOpenCourseRank.total.length > 0">
                      <td>{{index+1}}</td>
                      <td>{{item.schoolname}}</td>
                      <td>{{item.studynum}}</td>
                      <td>{{item.total}}</td>
                    </tr>
                    <tr v-show="movieOpenCourseRank.total.length == 0" class="nothing">
                      <td colspan="4">无</td>
                    </tr>
                  </table>
                </div>
                <div class="chart_name">表 7 各院校参建在线精品课程数量排名（前十名）</div>
              </div>

              <!-- 图 2 近一年教师和学生访问情况 -->
              <div class="chart_box">
                <p>（2）参建课程数量专业大类分布</p>
                <p>截止到2022年9月30日，河北省课程覆盖{{movieOpenCourseType.dataList.length}}个专业大类。从专业大类分布看，所属{{movieOpenCourseType.Frist.name}}的课程最多，一共{{movieOpenCourseType.Frist.value}}门课程，占比达{{((movieOpenCourseType.Frist.value / movieOpenCourseType.Total)*100).toFixed(2)}}%，具体分布如下图所示：</p>
                <div class="standards_content echartsHeight">
                  <circularChart :refId="'typeDistributionChart'" :datas='movieOpenCourseType.dataList' :colorName='1' :innerText="'数量'" :titleLeft="'32%'" :legendBackgroundColor="true" :legendLeft="'60%'" :circleSize="80" :isScroll="true"></circularChart>
                </div>
                <div class="chart_name">图 42 视频公开课专业大类分布情况</div>
              </div>
            </div>

            <div class="chart_box">
              <h3>4.1.2. 视频公开课访问情况</h3>
              <p>
                截止到2022年9月30日，河北省视频公开课共计访问量{{movieOpenCourseRank.visitsTotal}}，访问量最高的课程是邢台职业技术学院的《{{movieOpenCourseRank.visitsFrist.courseName}}》，具体访问量排名前十名的课程信息如下：
              </p>
              <!-- 图 1 用户类型分布(单位：人) -->
              <div class="biaoge">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>课程</th>
                    <th>课程负责人</th>
                    <th>所属院校</th>
                    <th>课程类型</th>
                    <th>访问量</th>
                  </tr>

                  <tr v-for="(item,index) in movieOpenCourseRank.visits" :key="index" v-show="movieOpenCourseRank.visits.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.courseName}}</td>
                    <td>{{item.majorTeacher}}</td>
                    <td>{{item.schoolName}}</td>
                    <td>{{item.courseClass}}</td>
                    <td>{{item.courseTotalVisit}}</td>
                  </tr>
                  <tr v-show="movieOpenCourseRank.visits.length == 0" class="nothing">
                    <td colspan="4">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 13 河北省视频公开课访问量排名（前十名）</div>
            </div>

            <div class="chart_box">
              <h3>4.1.3. 视频公开课选课情况</h3>
              <p>
                截止到2022年9月30日，河北省视频公开课共计选课人数{{movieOpenCourseRank.studyTotal}}人，选课人数最多的课程是{{movieOpenCourseRank.studyFrist.schoolname}}学院的《{{movieOpenCourseRank.studyFrist.name}}》，选课人数前十名的课程信息如下：
              </p>
              <!-- 图 1 用户类型分布(单位：人) -->
              <div class="biaoge">
                <table border="0" cellpadding="0" cellspacing="0" width="100%" bordercolor="#fff" class="course">
                  <tr>
                    <th>排名</th>
                    <th>课程</th>
                    <th>课程负责人</th>
                    <th>所属院校</th>
                    <th>课程类型</th>
                    <th>选课人数</th>
                  </tr>

                  <tr v-for="(item,index) in movieOpenCourseRank.study" :key="index" v-show="movieOpenCourseRank.study.length > 0">
                    <td>{{index+1}}</td>
                    <td>{{item.name}}</td>
                    <td>{{item.teacher}}</td>
                    <td>{{item.schoolname}}</td>
                    <td>{{item.courseclass}}</td>
                    <td>{{item.num}}</td>
                  </tr>
                  <tr v-show="movieOpenCourseRank.study.length == 0" class="nothing">
                    <td colspan="6">无</td>
                  </tr>
                </table>
              </div>
              <div class="chart_name">表 14 河北省视频公开课选课人数排名（前十名）</div>
            </div>
          </div>
        </div>

      </div>

      <el-backtop></el-backtop>
    </div>
  </div>
</template>

<script>
import circularChart from '@/components/chart/circularChart.vue'; // 引入圆形图表
import vcolumnarChart from '@/components/chart/vcolumnarChart.vue'; // 引入竖柱状图图表
import tcolumnarChart from '@/components/chart/tcolumnarChart.vue'; // 引入横柱图图表
import discountChart from '@/components/chart/discountChart.vue'; // 引入折线图图表
import waterDropChart from '@/components/chart/waterDropChart.vue'; // 引入水滴图图表
import distributionChart from '@/components/chart/distributionChart.vue'; // 地图
export default {
  components: {
    circularChart,
    vcolumnarChart,
    tcolumnarChart,
    discountChart,
    waterDropChart,
    distributionChart
  },
  data() {
    return {
      // 数据总览
      overview: {
        boutiqueCount: null,
        openCount: null,
        platForm: null,
        schoolCount: null,
        total: null,
        zyk: null,
        zykCount: null
      },
      // 用户信息
      userData: {
        student: null,
        teacher: null,
        num: null,
        total: null
      },
      // 用户建设及应用
      userType: {
        dataList: [],
        student: {},
        teacher: {},
        total: null,
        Sproportion: null,
        Tproportion: null
      },
      // 学生 + 老师 访问量
      userTypeVisit: {
        dataList: [],
        dataList2: [],
        Stotal: null,
        Ttotal: null,
        legendList: [],
        legendList2: [],
        transverseData: [],
        colorList: []
      },
      // 课程建设情况
      courseBuild: {
        dataList: [],
        total: null,
        MaxArr: {},
      },
      // 课程专业大类建设情况
      coursesTop: {
        dataList: [],
        transverseData: [],
        colorList: [],
        fristItem: {},
        secondItem: {}
      },
      // 近一年课程被访问总量
      courseTalk: {
        dataList: [],
        transverseData: [],
        colorList: [],
        courseTotal: null,
        courseAvg: null
      },

      // 近一年资源访问总量
      resouceTalk: {
        dataList: [],
        transverseData: [],
        colorList: [],
      },
      // 课程访问量排名
      courseRank: {
        dataList: [],
        MaxArr: [],
        Frist: {}
      },
      // 资源类型占比
      resourceType: {
        dataList: [],
        TableDataList: [],
        colorList: [],
        Max: [],
        total: null,
        resourceTotal: null,
        resourceAvg: null,
        tableTop: {},
        keyArr: [],
        valueArr: []
      },
      // 教师排名
      tearcherRank: {
        dataList: [],
        transverseData: [],
        colorList: [],
        Frist: {}
      },
      // 学生排名
      studentRank: {
        dataList: [],
        transverseData: [],
        colorList: [],
        Frist: {},
        total: null
      },
      // 各省交流话术排名
      schoolComRank: {
        dataList: [],
        transverseData: [],
        colorList: [],
        Frist: {},
        Second: {},
        total: null
      },
      // 开设课程排名
      opencourseRank: {
        dataList: [],
        transverseData: [],
        colorList: [],
        Frist: {},
        total: null
      },
      //  院校资源建设 
      schoolResource: {
        dataList: [],
        transverseData: [],
        colorList: [],
        Frist: {},
        total: null
      },
      // 资源访问
      schoolResourceVisit: {
        dataList: [],
        transverseData: [],
        colorList: [],
        Frist: {},
        total: null
      },
      // 区间内新增用户，课程，资源数量趋势
      sectionUCR: {
        // 区间内用户新增
        userNewDataList: [],
        userNewTransverseData: [],
        userNewTotal: null,
        // 区间内用户访问
        uservisitsDataList: [],
        uservisitsTransverseData: [],
        userVisitsTotal: null,
        //  区间内课程新增
        courseNewDataList: [],
        courseNewTransverseData: [],
        courseNewTotal: null,
        // 区间内课程访问
        courseVisitsDataList: [],
        courseVisitsTransverseData: [],
        courseVisitsTotal: null,

        // 区间内资源新增
        resourceNewDataList: [],
        resourceNewTransverseData: [],
        resourceNewTotal: null,

        // 区间内资源访问
        resourceVisitsDataList: [],
        resourceVisitsTransverseData: [],
        resourceVisitsTotal: null,

        colorList: []
      },
      // 资源库总体情况
      zykAll: {
        professionProvinceTotal: null,
        countryProvinceTotal: null,
        provinceProvinceTotal: null,
        schoolProvinceTotal: null,
        length: []
      },
      // 资源库用户情况
      zykUser: {
        dataList: [],
        total: null,
        student: {},
        tearcher: {},
        enterprise: {},
        social: {}
      },
      // 院校注册用户数及活跃用户数
      schoolActive: {
        school: '',
        value: '',
        activeUserCount: ''
      },
      // 资源库用户访问量
      zykUserVisit: {
        dataList: [],
        Frist: {},
        Second: {},
        Thrend: {},
        total: null,
      },
      // 院校活跃用户数排名
      zykUserActive: {
        dataList: [],
        total: null
      },
      // 资源库课程建设情况
      zykCourseBuild: {
        dataList: [],
        standard: null,
        personality: null,
        name: '',
        zykName: ''
      },
      // 专业大类分析
      zykBigType: {
        dataList: [],
        Max: {},
        total: null
      },
      // 资源库用户运行情况
      zykSection: {
        userActiveTotal: null,
        userActiveLogNum: null,
        userActiveList: [],
        SNumber: [],
        TNumber: [],
        Social: [],
        ENumber: [],
        userActiveDataList: [],
        userActiveTransverseData: [],
        color: [],
        legendList: [],

        userData: [],
        userTranserve: []
      },
      // 区间内用户新增数量
      zykSectionUserAdd: {
        dataList: [],
        transverseData: [],
        colorList: [],
        Ttotal: null,
        Stotal: null
      },
      // 资源库访问情况排名
      zykTalkRank: {
        dataList: [],
        lastList: [],
        Frist: {},
        Last: {}
      },

      // 资源库用户活跃情况排名
      zykUserActiveRank: {
        dataList: [],
        Frist: {},
        Second: {},
        Thrend: {}
      },

      // 资源库访问量排名
      zykVisiRank: {
        dataList: [],
        colorList: [],
        transverseData: [],
        total: null
      },
      // 资源运行情况 
      zykResource: {
        dataList: [],
        colorList: [],
        transverseData: [],
        Frist: {},
        total: null
      },
      // 在线精品课
      onlineboutique: {
        dataList: [],
        datas1: {},
        datas2: {},
        datas3: {},
        datas4: {},
        datas5: {},
        datas6: {},
        datas7: {},
        datas8: {},
      },

      // 在线精品课_课程分级数量
      onlineboutiqueLevel: {
        counrtyList: [],
        provinceList: [],
        schoolList: [],
        flot: null,
        total: null
      },

      // 参建课程数量排名
      onlineboutiqueCourseRank: {
        total: [],
        CourseRankFrist: {},
        courseTotal: null,

        visits: [],
        visitsFrist: {},
        visitsTotal: null,

        semester: [],
        semesterTotal: null,
        semesterFrist: {},

        study: [],
        studyTotal: null,
        studyFrist: {}
      },

      // 在线精品课_课程专业大类分布
      onlineboutiqueCourseType: {
        dataList: [],
        total: null,
        Frist: []
      },

      // 视频公开课数据总览
      movieOpen: {
        datas1: {},
        datas2: {},
        datas3: {},
        datas4: {},
        datas5: {},
        datas6: {},
      },
      // 参建课程数量排名
      movieOpenCourseRank: {
        total: [],
        CourseRankFrist: {},
        courseTotal: null,

        visits: [],
        visitsFrist: {},
        visitsTotal: null,

        semester: [],
        semesterTotal: null,
        semesterFrist: {},

        study: [],
        studyTotal: null,
        studyFrist: {}
      },

      movieOpenCourseType: {
        dataList: [],
        Total: null,
        Frist: []
      },

      movieLeavel: {
        datas1: [],
        datas2: [],
        datas3: [],
        datas4: [],
        total: null
      },
      year: '',
      yearAndMonthly: '',
      yearMonthText: '',
      zykStatus: '已立项',
      colorList: ['#3B85FB', '#FD398E', '#8B68F1', '#EE6F5E', '#E0D35F', '#5470C6', '#DE7E4B', '#DE524B'], // 柱状图或折线图的颜色
      color: ['#ffd9d9', '#ff0000', '#8B68F1', '#EE6F5E', '#E0D35F', '#5470C6', '#DE7E4B', '#DE524B'],
      header: {
        allHostUnit: '',
        coHostUnit: [],
        endTime: '',
        hostUnit: '',
        startTime: '',
        status: '',
        zykName: '',
        zykNum: ''
      },

      province: '河北',
      loading: '', // 是否导出加载中
    };
  },
  created() {
    if (this.$route.query) {

      this.$route.query.zykName = decodeURIComponent(this.$route.query.zykName);
      const year = this.$route.query.yearOrMonth
      const monthly = this.$route.query.yearOrMonth
      // const year = this.$route.query.yearOrMonth.substring(0, 4);
      // const monthly = this.$route.query.yearOrMonth.substring(4, this.$route.query.yearOrMonth.length);
      this.$route.query.startTime = `${year}-${monthly}-${1}`;
      this.$route.query.endTime = `${year}-${monthly}-${new Date(year, monthly, 0).getDate()}`;
      this.header = this.$route.query;
      this.year = `${year}-${monthly}`;
      this.yearAndMonthly = this.$route.query.yearOrMonth;
      this.yearMonthText = `2022年上半年运行数据分析报告`;
    }
    this.getZykStatus();         //   获取资源库状态
    this.fenxi()                 //   年度基本信息


    //  1. 用户数据                       //   用户数据
    this.dataOverviewHandler()           //   数据总览
    this.userDataHandler()
    //  1.1.1  用户建设及应用 
    this.userTypeHandler()              //   用户类型分布
    this.userTypeVisitHandler()        //    用户访问量

    //  1.1.2  课程建设情况
    this.courseBuildHandler()         //      课程建设情况
    this.coursesTopHandler()          //      课程专业大类建设情况
    this.courseTalkHandler()          //     近一年课程被访问总量   
    this.courseRankHandler()          //     课程访问量排名
    // 1.1.3  资源建设情况
    this.resourceHandler()
    // 1.2 
    this.tearcherRankHandler()      //      参与教师排名
    this.studentRankHandler()       //      参与学生排名
    this.schoolComRankHandler()     //      参与交流
    // 1.2.2. 院校课程建设及应用情况
    this.opencourseRankHandler()    //      开设课程排名
    // 1.2.3. 院校资源建设及应用情况
    this.schoolResourceHandler()          //   院校资源建设情况排名
    this.schoolResourceVisitHandler()     //  院校资源访问量排名
    this.sectionUCRhandler()              //  区间内新增用户，课程，资源数量趋势

    // 2.专业教学资源库应用分析
    // 2.1.1 资源库总体情况
    this.zykAllHandler()                 //   资源库总体情况
    this.zykUserHandler()                //   资源库用户情况
    this.schoolActiveHandler()           //   院校注册用户数及活跃用户数
    this.zykUserVisitHandler()          //    资源库用户访问量
    this.zykUserActiveHandler()         //    院校活跃用户数排名

    // 2.1.2 课程建设及应用情况   
    this.zykCourseBuildHandler()       //      资源库课程建设情况
    // 2.1.3 在 1.1.3
    // 2.1.4. 资源库总体应用情况分析
    this.zykBigTypeHandler()          //        资源库专业大类分析
    // 2.2.1  
    this.zykSectionHandler()          //        区间内资源库用户运用建设
    this.zykSectionUserAddHandler()   //        区间用户新增数量
    this.zykUserActiveRankTop()       //        资源库用户活跃情况排名

    this.zykTalkRankHandler()         //        资源库访问情况排名
    this.zykVisiRanktHandler()        //        资源库上半年课程访问量排名
    this.zykResourceHandler()         //        资源库资源运行情况


    // 3. 河北省在线精品课应用分析
    // 3.1.在线精品课程建设及应用情况
    this.onlineboutiqueHandler()              //    在线精品课数据总览
    this.onlineboutiqueLevelHandler()         //    在线精品课_课程分级数量
    this.onlineboutiqueCourseRankHandler()    //    在线精品课数参建课程数量排名 
    this.onlineboutiqueCourseTypeHandler()    //    在线精品课_课程专业大类分布

    // 4.河北省视频公开课应用分析
    this.movieOpenHandler()                   //    视频公开课数据总览    
    this.movieOpenLevelHandler()
    this.movieOpenCourseRankHandler()         //    视频公开课程数量排名
    this.movieOpenCourseTypeHandler()         //    视频公开课_课程专业大类分布 
  },
  methods: {
    // 导出月报
    toImage() {
      this.loading = this.$loading({
        lock: true,
        text: '正在导出中，请稍后...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      });

      this.$axios.post(this.$apiurls.exportMonthReport, {
        courseName: '',
        isAll: false,
        month: this.yearAndMonthly,
        reportType: 0,
        zykId: sessionStorage.getItem('zykId'),
        zykName: this.header.zykName,
        zykNum: this.header.zykNum,
      }, {
        loading: false,
      }).then((res) => {
        if (res) {
          window.open(res.data);
          this.loading.close();
        }
      }).catch(() => {
        this.loading.close();
      });
    },

    // 获取资源库状态
    getZykStatus() {
      this.$axios.post(this.$apiurls.report_monthly_getZykStatus, sessionStorage.getItem('zykId'), {
        loading: false,
      }).then((res) => {
        if (res) {
          this.zykStatus = res.data;
        }
      });
    },
    //  地图
    shengfenPer() {
      this.$axios.post(this.$apiurls.studentPortrait_getStudentProvinceUsersEchart, {
        loading: false,
      }).then((res) => {
        if (res) {
          this.shengfenperson.dataList = res.data
          this.shengfenperson.colorList = this.color
          console.log(this.shengfenperson);
        }
      });
    },
    // 年度基本信息
    fenxi() {
      this.$axios.post(this.$apiurls.report_yaer_getZykInformationVo, {
        loading: false
      }).then((res) => {
        this.header = res.data
        this.header.allHostUnit = res.data.allHostUnit.replace(',', '，');
      })
    },
    dataOverviewHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportOverview, this.province, {
        loading: false
      }).then((res) => {
        this.overview.boutiqueCount = res.data.boutiqueCount
        this.overview.openCount = res.data.openCount
        this.overview.platForm = res.data.platForm
        this.overview.schoolCount = res.data.schoolCount
        this.overview.total = res.data.total
        this.overview.zyk = res.data.zyk
        this.overview.zykCount = res.data.zykCount
      })
    },
    // 用户数据
    userDataHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportUserCount, this.province, {
        loading: false
      }).then((res) => {
        this.userData.num = res.data.num
        this.userData.student = res.data.student
        this.userData.teacher = res.data.teacher
        this.userData.total = res.data.total
      })
    },
    // 图 1 用户类型分布
    userTypeHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportUserBuild, this.province, {
        loading: false
      }).then((res) => {
        for (let i = 0; i < res.data.name.length; i++) {
          this.userType.dataList.push({ name: res.data.name[i], value: res.data.value[i] })
          this.userType.total += res.data.value[i]
        }

        this.userType.student = this.userType.dataList.find(item => item.name == '学生')
        this.userType.teacher = this.userType.dataList.find(item => item.name == '教师')
        this.userType.Sproportion = ((this.userType.student.value / this.userType.total) * 100).toFixed(2)
        this.userType.Tproportion = ((this.userType.teacher.value / this.userType.total) * 100).toFixed(2)
      })
    },
    // 图 2 学生老师用户访问量
    userTypeVisitHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportUserVisits, this.province, {
        loading: false
      }).then((res) => {
        console.log(res.data);

        let student = res.data.student
        let teacher = res.data.teacher

        let enterprise = res.data.enterprise
        let social = res.data.social

        this.userTypeVisit.transverseData = student.name
        this.userTypeVisit.dataList.push(student.value, teacher.value)
        this.userTypeVisit.legendList = ['老师', '学生']

        this.userTypeVisit.dataList2.push(social.value, enterprise.value)
        this.userTypeVisit.legendList2 = ['社会学习者', '企业用户']


        this.userTypeVisit.colorList = this.colorList
        this.userTypeVisit.Stotal = res.data.studentTotal
        this.userTypeVisit.Ttotal = res.data.teacherTotal
      })
    },
    // 图 3 课程建设 
    courseBuildHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportCourseBuild, this.province, {
        loading: false
      }).then((res) => {
        let datas = []
        datas.push({
          name: '资源库课程数',
          value: res.data.courseTotal
        }, {
          name: '视频公开课',
          value: res.data.publicCourse
        }, {
          name: '在线精品课',
          value: res.data.onlineCourse
        })
        this.courseBuild.dataList = datas

        function Sort(a, b) {
          return b.value - a.value
        }
        let sortArr = this.courseBuild.dataList.sort(Sort)
        datas.forEach(item => {
          this.courseBuild.total += item.value
        })
        this.courseBuild.MaxArr = sortArr[0]
      })
    },
    // 图 4 专业大类课程数量排名（前十名）
    coursesTopHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportCourseBuildClass, this.province, {
        loading: false
      }).then((res) => {

        function Sort(a, b) {
          return b.value - a.value
        }
        let datas = res.data.sort(Sort)
        datas.forEach(item => {
          this.coursesTop.dataList.push(item.value)
          this.coursesTop.transverseData.push(item.name)
        })

        this.coursesTop.fristItem = datas[0]
        this.coursesTop.secondItem = datas[1]

        this.coursesTop.colorList = this.colorList
      })
    },
    // 图 5 近一年课程被访问总量
    courseTalkHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportCourseMonthVisits, this.province, {
        loading: false
      }).then((res) => {
        this.courseTalk.dataList = res.data.course.value
        this.courseTalk.transverseData = res.data.course.name
        this.courseTalk.colorList = this.colorList
        this.courseTalk.courseTotal = res.data.courseTotal
        this.courseTalk.courseAvg = res.data.courseAvg

        this.resouceTalk.dataList = res.data.resouce.value
        this.resouceTalk.transverseData = res.data.resouce.name
        this.resouceTalk.colorList = this.colorList
      })
    },
    // 表 1 课程访问量排名
    courseRankHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportCourseRank, this.province, {
        loading: false
      }).then((res) => {
        this.courseRank.dataList = res.data

        function Sort(a, b) {
          return b.courseTotalVisit - a.courseTotalVisit
        }

        this.courseRank.dataList.sort(Sort)
        this.courseRank.Frist = this.courseRank.dataList[0]
      })
    },

    // 资源建设情况
    resourceHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportResourceBuild, this.province, {
        loading: false
      }).then((res) => {
        // console.log(res.data, 'aaaaaaaaaaaaa');

        // res.data.resourceRank.map(item => {
        //   let str = item.name
        //   let i = str.indexOf(',')
        //   let str1 = str.slice(i + 1,)
        //   let str2 = str.slice(0, i)
        //   this.$set(item, 'type', str1)
        //   this.$set(item, 'name', str2)
        // })


        let textArr = res.data.resourceRank.filter(item => item.resourceType === '文本类')
        let vedioArr = res.data.resourceRank.filter(item => item.resourceType === '视频类')
        let pptArr = res.data.resourceRank.filter(item => item.resourceType === '音频类')
        let weikeArr = res.data.resourceRank.filter(item => item.resourceType === '微课类')


        let textTotal = null
        let vedioTotal = null
        let pptTotal = null
        let weikeTotal = null

        textArr.forEach(item => {
          textTotal += item.num
        })

        vedioArr.forEach(item => {
          vedioTotal += item.num
        })


        pptArr.forEach(item => {
          pptTotal += item.num
        })

        weikeArr.forEach(item => {
          weikeTotal += item.num
        })

        this.resourceType.dataList.push({
          name: '文本类',
          value: textTotal
        }, {
          name: '视频类',
          value: vedioTotal
        }, {
          name: '音频类',
          value: pptTotal
        }, {
          name: '微课类',
          value: weikeTotal
        })


        function Sort(a, b) {
          return b.value - a.value
        }
        this.resourceType.dataList.sort(Sort)


        this.resourceType.Max = this.resourceType.dataList[0]
        this.resourceType.TableDataList = res.data.resourceRank
        this.resourceType.TableDataList.forEach(item => {
          this.resourceType.total += item.num
        })

        // 表格数据
        this.resourceType.tableTop = this.resourceType.TableDataList[0]
        this.resourceType.resourceTotal = res.data.resourceTotal
        this.resourceType.resourceAvg = res.data.resourceAvg

        // 图 26 
        this.resourceType.dataList.forEach(item => {
          this.resourceType.keyArr.push(item.name)
          this.resourceType.valueArr.push(item.value)
        })



        this.resourceType.colorList = this.colorList
      })
    },



    tearcherRankHandler() {
      this.$axios.post(this.$apiurls.resourceBaseMonitoringCloudMap_getProvinceTeacherNumRank, this.province, {
        loading: false
      }).then((res) => {
        this.tearcherRank.dataList = res.data.value
        this.tearcherRank.transverseData = res.data.name
        this.tearcherRank.colorList = this.colorList
        let datas = []
        for (let i = 0; i < res.data.value.length; i++) {
          datas.push({ name: res.data.name[i], value: res.data.value[i] })
        }
        function Sort(a, b) {
          return b.value - a.value
        }
        datas.sort(Sort)
        this.tearcherRank.Frist = datas[0]
      })
    },

    studentRankHandler() {
      this.$axios.post(this.$apiurls.resourceBaseMonitoringCloudMap_getProvinceStudentNumRank, this.province, {
        loading: false
      }).then((res) => {
        this.studentRank.dataList = res.data.value
        this.studentRank.transverseData = res.data.name
        this.studentRank.colorList = this.colorList
        let datas = []
        for (let i = 0; i < res.data.value.length; i++) {
          datas.push({ name: res.data.name[i], value: res.data.value[i] })
          this.studentRank.total += res.data.value[i]
        }

        function Sort(a, b) {
          return b.value - a.value
        }
        datas.sort(Sort)
        this.studentRank.Frist = datas[0]
      })
    },

    schoolComRankHandler() {
      this.$axios.post(this.$apiurls.resourceBaseMonitoringCloudMap_getProvinceInteractionNumRank, this.province, {
        loading: false
      }).then((res) => {
        this.schoolComRank.dataList = res.data.value
        this.schoolComRank.transverseData = res.data.name
        this.schoolComRank.colorList = this.colorList
        let datas = []
        for (let i = 0; i < res.data.value.length; i++) {
          this.schoolComRank.total += res.data.value[i]
          datas.push({ name: res.data.name[i], value: res.data.value[i] })
        }
        function Sort(a, b) {
          return b.value - a.value
        }
        datas.sort(Sort)
        this.schoolComRank.Frist = datas[0]
        this.schoolComRank.Second = datas[1]
      })
    },

    // 开设课程量排名
    opencourseRankHandler() {
      this.$axios.post(this.$apiurls.resourceBaseMonitoringCloudMap_getProvinceCourseNumRank, this.province, {
        loading: false
      }).then((res) => {
        this.opencourseRank.dataList = res.data.value
        this.opencourseRank.transverseData = res.data.name
        this.opencourseRank.colorList = this.colorList
        let datas = []
        for (let i = 0; i < res.data.value.length; i++) {
          this.opencourseRank.total += res.data.value[i]
          datas.push({ name: res.data.name[i], value: res.data.value[i] })
        }
        function Sort(a, b) {
          return b.value - a.value
        }
        datas.sort(Sort)
        this.opencourseRank.Frist = datas[0]
      })
    },

    // 院校资源建设及应用情况
    schoolResourceHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportSchoolResourceBuild, this.province, {
        loading: false
      }).then((res) => {
        this.schoolResource.dataList = res.data.value
        this.schoolResource.transverseData = res.data.name
        this.schoolResource.colorList = this.colorList
        let datas = []
        for (let i = 0; i < res.data.value.length; i++) {
          this.schoolResource.total += res.data.value[i]
          datas.push({ name: res.data.name[i], value: res.data.value[i] })
        }
        function Sort(a, b) {
          return b.value - a.value
        }
        datas.sort(Sort)
        this.schoolResource.Frist = datas[0]
      })
    },

    // 院校资源访问量排名
    schoolResourceVisitHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportSchoolResourceVisitsRank, this.province, {
        loading: false
      }).then((res) => {
        this.schoolResourceVisit.dataList = res.data.value
        this.schoolResourceVisit.transverseData = res.data.name
        this.schoolResourceVisit.colorList = this.colorList
        let datas = []
        for (let i = 0; i < res.data.value.length; i++) {
          this.schoolResourceVisit.total += res.data.value[i]
          datas.push({ name: res.data.name[i], value: res.data.value[i] })
        }
        function Sort(a, b) {
          return b.value - a.value
        }
        datas.sort(Sort)
        this.schoolResourceVisit.Frist = datas[0]
      })
    },

    // 区间内新增用户，课程，资源数量趋势
    sectionUCRhandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportNewBuildRange, { endDay: "2022-09-30", province: this.province, startDay: "2022-07-01" }, {
        loading: false
      }).then((res) => {
        // 用户新增趋势
        this.sectionUCR.userNewDataList = res.data.userNew.value
        this.sectionUCR.userNewTransverseData = res.data.userNew.name
        this.sectionUCR.userNewDataList.forEach(item => {
          this.sectionUCR.userNewTotal += item
        })

        // 用户访问趋势
        this.sectionUCR.uservisitsDataList = res.data.userVisits.value
        this.sectionUCR.uservisitsTransverseData = res.data.userVisits.name
        this.sectionUCR.uservisitsDataList.forEach(item => {
          this.sectionUCR.userVisitsTotal += item
        })

        // 课程新增趋势
        this.sectionUCR.courseNewDataList = res.data.courseNew.value
        this.sectionUCR.courseNewTransverseData = res.data.courseNew.name
        this.sectionUCR.courseNewDataList.forEach(item => {
          this.sectionUCR.courseNewTotal += item
        })

        // 课程访问量趋势
        this.sectionUCR.courseVisitsDataList = res.data.courseVisits.value
        this.sectionUCR.courseVisitsTransverseData = res.data.courseVisits.name
        this.sectionUCR.courseVisitsDataList.forEach(item => {
          this.sectionUCR.courseVisitsTotal += item
        })

        // 资源新增趋势
        this.sectionUCR.resourceNewDataList = res.data.resourceNew.value
        this.sectionUCR.resourceNewTransverseData = res.data.resourceNew.name
        this.sectionUCR.resourceNewDataList.forEach(item => {
          this.sectionUCR.resourceNewTotal += item
        })
        // 资源访问趋势
        this.sectionUCR.resourceVisitsDataList = res.data.resourceVisits.value
        this.sectionUCR.resourceNewTransverseData = res.data.resourceVisits.name
        this.sectionUCR.resourceVisitsDataList.forEach(item => {
          this.sectionUCR.resourceVisitsTotal += item
        })


        this.sectionUCR.colorList = this.colorList
      })
    },

    // 资源库总体情况
    zykAllHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportZykOverview, this.province, {
        loading: false
      }).then((res) => {
        this.zykAll.countryProvinceTotal = res.data.countryProvinceTotal
        this.zykAll.provinceProvinceTotal = res.data.provinceProvinceTotal
        this.zykAll.schoolProvinceTotal = res.data.schoolProvinceTotal
        this.zykAll.professionProvinceTotal = res.data.professionProvinceTotal
        this.zykAll.length.push(res.data.countryProvinceTotal, res.data.professionProvinceTotal, res.data.schoolProvinceTotal, res.data.provinceProvinceTotal)
      })
    },

    // 资源库用户情况
    zykUserHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportZykUser, this.province, {
        loading: false
      }).then((res) => {
        for (let i = 0; i < res.data.value.length; i++) {
          this.zykUser.dataList.push({ name: res.data.name[i], value: res.data.value[i] })
          this.zykUser.total += res.data.value[i]
        }

        this.zykUser.student = this.zykUser.dataList.find(item => item.name == '学生')
        this.zykUser.tearcher = this.zykUser.dataList.find(item => item.name == '教师')
        this.zykUser.enterprise = this.zykUser.dataList.find(item => item.name == '社会实习者')
        this.zykUser.enterprise.name = '社会学习者'
        this.zykUser.social = this.zykUser.dataList.find(item => item.name == '企业员工')
      })
    },

    // 院校注册用户数及活跃用户数
    schoolActiveHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportUserActiveTotal, this.province, {
        loading: false
      }).then((res) => {
        this.schoolActive.school = res.data.school
        this.schoolActive.value = res.data.value
        this.schoolActive.activeUserCount = res.data.activeUserCount
      })
    },
    // 资源库用户访问量
    zykUserVisitHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportZykVisitsRank, this.province, {
        loading: false
      }).then((res) => {
        this.zykUserVisit.dataList = res.data

        this.zykUserVisit.Frist = res.data[0]
        this.zykUserVisit.Second = res.data[1]
        this.zykUserVisit.Thrend = res.data[2]


        res.data.forEach(item => {
          this.zykUserVisit.total += item.logNum
        })
      })
    },
    // 院校活跃用户数排名
    zykUserActiveHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportUserActiveRank, this.province, {
        loading: false
      }).then((res) => {
        this.zykUserActive.dataList = res.data
        res.data.forEach(item => {
          this.zykUserActive.total += item.activeNum
        })
      })
    },
    // 资源库课程建设情况
    zykCourseBuildHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportZykCourseBuild, this.province, {
        loading: false
      }).then((res) => {
        this.zykCourseBuild.standard = res.data.standard
        this.zykCourseBuild.personality = res.data.personality
        this.zykCourseBuild.transverseData = ['标准化课程', '个性化课程']
        this.zykCourseBuild.dataList.push(res.data.standard, res.data.personality)
        this.zykCourseBuild.colorList = this.colorList
        this.zykCourseBuild.name = res.data.name
        this.zykCourseBuild.zykName = res.data.zykName
      })
    },

    // 专业大类分析
    zykBigTypeHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportZykBigClassBuild, this.province, {
        loading: false
      }).then((res) => {
        this.zykBigType.dataList = res.data
        this.zykBigType.Max = this.zykBigType.dataList[0]
        this.zykBigType.dataList.forEach(item => {
          this.zykBigType.total += item.value
        })
      })
    },

    // 区间内资源库用户运用建设
    zykSectionHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportZykActiveUserReign, { endDay: "2022-09-30", province: this.province, startDay: "2022-07-01" }, {
        loading: false
      }).then((res) => {
        this.zykSection.userActiveTotal = res.data.userActiveTotal
        res.data.userActive.forEach(item => {
          this.zykSection.userActiveLogNum += item.logNum
        })

        this.zykSection.userActiveList = res.data.userActive.map(item => {
          let num = item.num
          let role = item.role
          let logNum = item.logNum
          return {
            num,
            role,
            logNum
          }
        })

        this.zykSection.SNumber = this.zykSection.userActiveList.find(item => item.role == '学生')
        this.zykSection.TNumber = this.zykSection.userActiveList.find(item => item.role == '教师')
        this.zykSection.Social = this.zykSection.userActiveList.find(item => item.role == '社会学习者')
        this.zykSection.ENumber = this.zykSection.userActiveList.find(item => item.role == '企业用户')
        this.zykSection.userActiveDataList = res.data.userActiveMonthRole.dataList
        this.zykSection.userActiveTransverseData = res.data.userActiveMonthRole.transverseData

        console.log(this.zykSection.userActiveDataList, this.zykSection.userActiveTransverseData);

        this.zykSection.legendList = res.data.userActiveMonthRole.legendList

        let datas1 = []
        let datas2 = []
        res.data.userActiveMonth.forEach(item => {
          datas1.push(item.value)
          datas2.push(item.name)
        })
        this.zykSection.userData = datas1
        this.zykSection.userTranserve = datas2
        this.zykSection.colorList = this.colorList
      })
    },

    // 区间内用户新增数量
    zykSectionUserAddHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportUserNewBuildRange, { endDay: "2022-09-30", province: this.province, startDay: "2022-07-01" }, {
        loading: false
      }).then((res) => {
        let datas1 = res.data.student
        let datas2 = res.data.teacher

        res.data.teacher.value.forEach(item => {
          this.zykSectionUserAdd.Ttotal += item
        })

        res.data.student.value.forEach(item => {
          this.zykSectionUserAdd.Stotal += item
        })

        datas1.name.forEach(item => {
          this.zykSectionUserAdd.transverseData.push(item)
        })

        this.zykSectionUserAdd.dataList.push(datas1.value, datas2.value)

        this.zykSectionUserAdd.colorList = this.colorList
        this.zykSectionUserAdd.lengdList = ['教师', '学生']
      })
    },
    // 资源库用户情况排名
    zykUserActiveRankTop() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportZykVisitsReign, { endDay: "2022-06-30", province: this.province, startDay: "2022-01-01" }, {
        loading: false
      }).then((res) => {
        this.zykUserActiveRank.dataList = res.data
        this.zykUserActiveRank.Frist = res.data[0]
        this.zykUserActiveRank.Second = res.data[1]
        this.zykUserActiveRank.Thrend = res.data[2]
      })
    },
    // 资源库访问情况排名
    zykTalkRankHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportZykVisitsReign, { endDay: "2022-09-30", province: this.province, startDay: "2022-07-01" }, {
        loading: false
      }).then((res) => {
        this.zykTalkRank.dataList = res.data.slice(0, 10)
        this.zykTalkRank.lastList = res.data.slice(-10)
        this.zykTalkRank.Frist = this.zykTalkRank.dataList[0]
        this.zykTalkRank.Last = this.zykTalkRank.lastList[this.zykTalkRank.lastList.length - 1]
      })
    },
    // 资源库上半年课程访问量排名
    zykVisiRanktHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportZykCourseReignRank, this.province, {
        loading: false
      }).then((res) => {
        res.data.forEach(item => {
          this.zykVisiRank.dataList.push(item.num)
          this.zykVisiRank.transverseData.push(item.name)
        })
        this.zykVisiRank.colorList = this.colorList

        this.zykVisiRank.dataList = this.zykVisiRank.dataList.slice(0, 10)
        this.zykVisiRank.transverseData = this.zykVisiRank.transverseData.slice(0, 10)
      })
    },

    // 资源库资源运行情况
    zykResourceHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportZykResourceStatus, { endDay: "2022-06-30", province: this.province, startDay: "2022-01-01" }, {
        loading: false
      }).then((res) => {
        res.data.logRank.forEach(item => {
          this.zykResource.total += item.num
          this.zykResource.dataList.push(item.num)
          this.zykResource.transverseData.push(item.zyk_name)
        })
        this.zykResource.Frist.value = this.zykResource.dataList[0]
        this.zykResource.Frist.name = this.zykResource.transverseData[0]

        this.zykResource.colorList = this.colorList
      })
    },


    // 3.
    // 在线精品课数据总览
    onlineboutiqueHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportOnlineCourseStat, { endDay: "2022-06-30", province: this.province, startDay: "2022-01-01" }, {
        loading: false
      }).then((res) => {
        let keyArr = Object.keys(res.data)
        let valueArr = Object.values(res.data)
        for (let i = 0; i < keyArr.length; i++) {
          this.onlineboutique.dataList.push({ name: keyArr[i], value: valueArr[i] })
          this.onlineboutique.datas1 = this.onlineboutique.dataList.find(item => item.name == '参建院校')
          this.onlineboutique.datas2 = this.onlineboutique.dataList.find(item => item.name == '学员所属单位数（个次）')
          this.onlineboutique.datas3 = this.onlineboutique.dataList.find(item => item.name == '总开课期数')
          this.onlineboutique.datas4 = this.onlineboutique.dataList.find(item => item.name == '总访问量')
          this.onlineboutique.datas5 = this.onlineboutique.dataList.find(item => item.name == '总课时数')
          this.onlineboutique.datas6 = this.onlineboutique.dataList.find(item => item.name == '总选课人数')
          this.onlineboutique.datas7 = this.onlineboutique.dataList.find(item => item.name == '教师参建人次')
          this.onlineboutique.datas8 = this.onlineboutique.dataList.find(item => item.name == '累计互动次数')
        }
      })
    },

    // 在线精品课_课程分级数量
    onlineboutiqueLevelHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportOnlineCourseCountByLevel, { type: 1, province: this.province }, {
        loading: false
      }).then((res) => {
        this.onlineboutiqueLevel.counrtyList = res.data[0]
        this.onlineboutiqueLevel.provinceList = res.data[1]
        this.onlineboutiqueLevel.schoolList = res.data[2]
        this.onlineboutiqueLevel.flot = res.data.length
        res.data.forEach(item => {
          this.onlineboutiqueLevel.total += item.num
        })
      })
    },

    // 参建课程数量排名
    onlineboutiqueCourseRankHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportOnlineCourseRank, { endDay: "2022-06-30", province: this.province, startDay: "2022-01-01" }, {
        loading: false
      }).then((res) => {


        this.onlineboutiqueCourseRank.total = res.data.total
        res.data.total.forEach(item => {
          this.onlineboutiqueCourseRank.courseTotal += item.total
        })
        this.onlineboutiqueCourseRank.CourseRankFrist = this.onlineboutiqueCourseRank.total[0]

        // 在线精品课访问情况
        this.onlineboutiqueCourseRank.visits = res.data.visits
        res.data.visits.forEach(item => {
          this.onlineboutiqueCourseRank.visitsTotal += item.courseTotalVisit
        })
        this.onlineboutiqueCourseRank.visitsFrist = this.onlineboutiqueCourseRank.visits[0]

        // 开课期数
        this.onlineboutiqueCourseRank.semester = res.data.semester
        res.data.semester.forEach(item => {
          this.onlineboutiqueCourseRank.semesterTotal += item.num
        })
        this.onlineboutiqueCourseRank.semesterFrist = this.onlineboutiqueCourseRank.semester[0]

        console.log(this.onlineboutiqueCourseRank.total, 'aaaaaaaaaaaaa');


        // 选课人数
        this.onlineboutiqueCourseRank.study = res.data.study
        res.data.study.forEach(item => {
          this.onlineboutiqueCourseRank.studyTotal += item.num
        })
        this.onlineboutiqueCourseRank.studyFrist = this.onlineboutiqueCourseRank.study[0]
      })
    },

    // 在线精品课_课程专业大类分布
    onlineboutiqueCourseTypeHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportOnlineCourseCategoryBuild, { type: 1, province: this.province }, {
        loading: false
      }).then((res) => {
        this.onlineboutiqueCourseType.dataList = res.data
        res.data.forEach(item => {
          this.onlineboutiqueCourseType.total += item.value
        })

        function Sort(a, b) {
          return b.value - a.value
        }
        this.onlineboutiqueCourseType.dataList.sort(Sort)

        this.onlineboutiqueCourseType.Frist = this.onlineboutiqueCourseType.dataList[0]
      })
    },


    // 4.
    // 视频公开课数据总览
    movieOpenHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportOnlineCourseStat, { type: 2, province: this.province }, {
        loading: false
      }).then((res) => {
        let keyArr = Object.keys(res.data)
        let valueArr = Object.values(res.data)
        let datas = []
        for (let i = 0; i < keyArr.length; i++) {
          datas.push({ name: keyArr[i], value: valueArr[i] })
        }
        this.movieOpen.datas1 = datas[0]
        this.movieOpen.datas2 = datas[1]
        this.movieOpen.datas3 = datas[2]
        this.movieOpen.datas4 = datas[3]
        this.movieOpen.datas5 = datas[4]
        this.movieOpen.datas6 = datas[5]
      })
    },

    // 视频公开课等级
    movieOpenLevelHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportOnlineCourseCountByLevel, { type: 2, province: this.province }, {
        loading: false
      }).then((res) => {

        this.movieLeavel.datas1 = res.data.find(item => item.kname == '公共基础课')
        this.movieLeavel.datas2 = res.data.find(item => item.kname == '国家规范教材')
        this.movieLeavel.datas3 = res.data.find(item => item.kname == '教学能力比赛')
        this.movieLeavel.datas4 = res.data.find(item => item.kname == '课程思政示范课')

        res.data.forEach(item => {
          this.movieLeavel.total += item.num
        })
      })
    },

    // 视频公开课程数量排名
    movieOpenCourseRankHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportOnlineCourseRank, { type: 2, province: this.province, }, {
        loading: false
      }).then((res) => {

        // 课程数排名
        this.movieOpenCourseRank.total = res.data.total
        res.data.total.forEach(item => {
          this.movieOpenCourseRank.courseTotal += item.total
        })
        this.movieOpenCourseRank.CourseRankFrist = this.movieOpenCourseRank.total[0]

        // 课程访问量排名
        this.movieOpenCourseRank.visits = res.data.visits
        res.data.visits.forEach(item => {
          this.movieOpenCourseRank.visitsTotal += item.courseTotalVisit
        })
        this.movieOpenCourseRank.visitsFrist = this.movieOpenCourseRank.visits[0]
        // 开课期数
        this.movieOpenCourseRank.semester = res.data.semester
        res.data.semester.forEach(item => {
          this.movieOpenCourseRank.semesterTotal += item.num
        })
        this.movieOpenCourseRank.semesterFrist = this.movieOpenCourseRank.total[0]

        // 选课人数
        this.movieOpenCourseRank.study = res.data.study
        res.data.study.forEach(item => {
          this.movieOpenCourseRank.studyTotal += item.num
        })
        this.movieOpenCourseRank.studyFrist = this.movieOpenCourseRank.study[0]
      })
    },

    // 视频公开课_课程专业大类分布
    movieOpenCourseTypeHandler() {
      this.$axios.post(this.$apiurls.provinceReport_getProvinceReportOnlineCourseCategoryBuild, { type: 2, province: this.province }, {
        loading: false
      }).then((res) => {

        this.movieOpenCourseType.dataList = res.data
        console.log(this.movieOpenCourseType.dataList.length);
        res.data.forEach(item => {
          this.movieOpenCourseType.Total += item.value
        })


        function Sort(a, b) {
          return b.value - a.value
        }

        this.movieOpenCourseType.dataList.sort(Sort)
        this.movieOpenCourseType.Frist = this.movieOpenCourseType.dataList[0]

      })
    },
    // 进度条上的百分比值转化
    teacherFormat() {
      return `${this.waterDrop.teacherNum}%`;
    },
    studentFormat() {
      return `${this.waterDrop.studentNum}%`;
    },
    resourceFormat() {
      return `${this.waterDrop.resourceNum}%`;
    },
    lastresourceFormat() {
      return `${this.waterDrop.lastresourceNum}%`;
    },
    majorteacherFormat() {
      return `${this.waterDrop.majorteacherNum}%`;
    },
    majorstudentFormat() {
      return `${this.waterDrop.majorstudentNum}%`;
    },
    unitteacherFormat() {
      return `${this.waterDrop.unitteacherNum}%`;
    },
    unitstudentFormat() {
      return `${this.waterDrop.unitstudentNum}%`;
    },
  },
};
</script>

<style scoped>
.analysisReport {
  width: 100%;
  background: #fff;
}

h1,
h2,
h3,
h4,
h5,
p {
  margin: 0px;
  padding: 0px;
}

.analysisReport_box {
  width: 70%;
  margin: 0px auto;
}

.header_titles {
  display: flex;
  justify-content: center;
  flex-flow: column;
  color: #000;
  text-align: center;
  position: relative;
}

.header_titles h1 {
  font-size: 34px;
  font-weight: bold;
  color: #1d244e;
  line-height: 30px;
  margin-top: 10px;
}
.header_titles span {
  font-size: 20px;
  margin-top: 50px;
}
.header_titles .monthly {
  font-size: 18px;
  font-weight: 400;
  color: #1d244e;
  line-height: 30px;
  margin-top: 6px;
}

.number_time {
  margin: 20px 0px;
}
.number_time div {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #707f9d;
  font-size: 17px;
}

.number_time p {
  width: 100%;
  height: 1px;
  background: #707f9d;
  margin-top: 8px;
}
.number_time p:last-child {
  opacity: 0.5;
  margin-top: 4px;
}

.division {
  width: 100%;
  height: 40px;
  position: relative;
  clear: both;
}
.division span {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1;
  background: #fff;
  font-weight: bold;
  font-size: 20px;
  color: #1d244e;
  font-size: 23px;
  padding: 0px 50px;
  line-height: 30px;
}

.chart_box {
  width: 100%;
  height: auto;
  margin-bottom: 60px;
  clear: both;
}

.chart_box h4 {
  font-weight: 700;
  font-size: 20px;
  color: #1d244e;
  /*text-indent: 40px;*/
  line-height: 45px;
}
.chart_box p {
  font-size: 20px;
  text-indent: 40px;
  line-height: 45px;
  color: #707f9d;
}

.chart_box .echartsHeight,
.layout,
.speed {
  width: 80%;
  height: calc(100vw / 1080 * 300);
  height: 400px;
  margin: 10px auto 0px;
}

.speed {
  width: 100%;
  height: auto;
}

.speed > div {
  width: 80%;
  font-size: 17px;
  color: #707f9d;
  line-height: 28px;
  margin: 20px auto;
}

.speed .el-col {
  margin-bottom: 15px;
}

.speed .el-col div {
  height: 40px;
  display: flex;
  align-items: center;
}

.chart_box .chart_name {
  text-align: center;
  font-size: 17px;
  color: #707f9d;
  clear: both;
}

.chart_box .notes {
  margin: 35px;
  line-height: 25px;
  font-size: 17px;
  color: #707f9d;
}

/* 布局 */
.layout {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.export {
  position: absolute;
  right: 10px;
  top: 10px;
}

.center {
  text-align: center;
}
.divorced {
  margin-top: 40px;
}

::v-deep .el-progress-bar__innerText {
  color: #000;
}
</style>

<style>
::-webkit-scrollbar {
  width: 10px !important;
  height: 14px;
  border-radius: 3px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

::-webkit-scrollbar-thumb {
  background-color: #c1c1c1 !important;
  border-radius: 3px;
}

.biaoge {
  width: 95%;
  /* height: 390px; */
  margin: 0px auto 25px;
}

.biaoge .twoTable {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}

.course {
  text-align: center;
  margin: 0px 10px;
}

.course tr {
  height: 35px;
  color: #707f9d;
  font-size: 15px;
}

.course tr:nth-child(2n) {
  background: #fff;
  color: #566178;
}

.course tr:nth-child(2n-1) {
  background: #7ed2ff;
  color: #566178;
}

.course tr:first-child {
  background: #66adff;
  color: #fff;
}

.chart_box {
  width: 100%;
  margin-bottom: 30px;
}

.chart_box h1 {
  font-size: 34px;
  margin-bottom: 50px;
}
.chart_box h2 {
  font-size: 28px;
  margin-bottom: 50px;
}
.chart_box h3 {
  font-size: 22px;
  margin-bottom: 50px;
}
.chart_box h4 {
  font-weight: 700;
  font-size: 18px;
  color: #1d244e;
  text-indent: 40px;
  line-height: 30px;
}
.chart_box p {
  font-size: 20px;
  text-indent: 40px;
  line-height: 28px;
  color: #707f9d;
}

.chart_box .echartsHeight {
  width: 80%;
  height: 380px;
  margin: 0px auto;
}

.chart_box .chart_name {
  text-align: center;
  font-size: 17px;
  color: #707f9d;
}

.chart_box .notes {
  margin: 35px;
  line-height: 25px;
  font-size: 14px;
  color: #707f9d;
}

.creditRanking {
  display: flex;
  justify-content: space-between;
  font-size: 17px;
  text-indent: 40px;
  line-height: 28px;
  color: #707f9d;
}
</style>
